import { render, staticRenderFns } from "./WallHome.vue?vue&type=template&id=f33e9216&"
import script from "./WallHome.vue?vue&type=script&lang=js&"
export * from "./WallHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports